export const apiErrorTypes = {
  resultError: {
    value: 0,
    name: '返回数据不合法',
    tagType: 'info',
  },
  late: {
    value: 1,
    name: '系统内部错误',
    tagType: 'warning',
  },
  leaveEarly: {
    value: 2,
    name: '访问失败',
    tagType: 'danger',
  },
};

export function findApiErrorType(apiErrorTypeValue) {
  for (const key in apiErrorTypes) {
    if (apiErrorTypeValue === apiErrorTypes[key].value) return [apiErrorTypes[key]];
  }
}
